/** Account settings + change-password strings for non-English locales. */

const mkCredentialFields = ({
  desc,
  current,
  newLabel,
  confirm,
  currentPh,
  newPh,
  confirmPh,
  confirmRequired,
  mismatch,
  currentRequired,
  updating,
  update,
  changed,
  invalidCurrent,
  changeFailed,
}) => ({
  changePasswordDesc: desc,
  currentPassword: current,
  newPassword: newLabel,
  confirmPassword: confirm,
  currentPasswordPlaceholder: currentPh,
  newPasswordPlaceholder: newPh,
  confirmPasswordPlaceholder: confirmPh,
  confirmRequired,
  passwordMismatch: mismatch,
  currentPasswordRequired: currentRequired,
  updatingPassword: updating,
  updatePassword: update,
  passwordChanged: changed,
  invalidCurrentPassword: invalidCurrent,
  passwordChangeFailed: changeFailed,
});

const mkSettings = (shell, credential) => ({ ...shell, ...credential });

export const SETTINGS_LOCALE_BLOCKS = {
  hi: mkSettings(
    {
      title: "सेटिंग्स",
      heroTitle: "खाता सेटिंग्स",
      intro: "अपने खाते की सुरक्षा, कानूनी दस्तावेज़ और खाता स्थिति प्रबंधित करें।",
      termsAndConditions: "नियम और शर्तें",
      termsLink: "नियम और शर्तें",
      termsLinkDesc: "पूरा कानूनी दस्तावेज़ देखें",
      readFullTerms: "पूरे नियम और शर्तें पढ़ें",
      accountActions: "खाता क्रियाएं",
      saveChanges: "बदलाव सहेजें",
      deleteAccount: "खाता हटाएं",
      deleteAccountBadge: "15-दिन की रिकवरी अवधि",
      deleteAccountDesc:
        "अपना मुख्य खाता और सभी परिवार प्रोफाइल स्थायी रूप से हटाएं। सब कुछ पुनर्स्थापित करने के लिए 15 दिनों के अंदर वापस साइन इन करें।",
    },
    mkCredentialFields({
      desc: "अपना लॉगिन पासवर्ड अपडेट करें",
      current: "वर्तमान पासवर्ड",
      newLabel: "नया पासवर्ड",
      confirm: "पासवर्ड की पुष्टि करें",
      currentPh: "वर्तमान पासवर्ड दर्ज करें",
      newPh: "नया पासवर्ड दर्ज करें",
      confirmPh: "नए पासवर्ड की पुष्टि करें",
      confirmRequired: "कृपया अपने पासवर्ड की पुष्टि करें",
      mismatch: "पासवर्ड मेल खाने चाहिए",
      currentRequired: "वर्तमान पासवर्ड आवश्यक है",
      updating: "अपडेट हो रहा है...",
      update: "पासवर्ड अपडेट करें",
      changed: "पासवर्ड सफलतापूर्वक बदला गया",
      invalidCurrent: "वर्तमान पासवर्ड गलत है",
      changeFailed: "पासवर्ड बदलने में विफल",
    })
  ),
  pa: mkSettings(
    {
      title: "ਸੈਟਿੰਗਾਂ",
      heroTitle: "ਖਾਤਾ ਸੈਟਿੰਗਾਂ",
      intro: "ਆਪਣੀ ਖਾਤਾ ਸੁਰੱਖਿਆ, ਕਾਨੂੰਨੀ ਦਸਤਾਵੇਜ਼ ਅਤੇ ਖਾਤਾ ਸਥਿਤੀ ਪ੍ਰਬੰਧਿਤ ਕਰੋ।",
      termsAndConditions: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
      termsLink: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
      termsLinkDesc: "ਪੂਰਾ ਕਾਨੂੰਨੀ ਦਸਤਾਵੇਜ਼ ਦੇਖੋ",
      readFullTerms: "ਪੂਰੇ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਪੜ੍ਹੋ",
      accountActions: "ਖਾਤਾ ਕਾਰਵਾਈਆਂ",
      saveChanges: "ਬਦਲਾਅ ਸੁਰੱਖਿਅਤ ਕਰੋ",
      deleteAccount: "ਖਾਤਾ ਮਿਟਾਓ",
      deleteAccountBadge: "15-ਦਿਨ ਦੀ ਰਿਕਵਰੀ ਮਿਆਦ",
      deleteAccountDesc:
        "ਆਪਣਾ ਮੁੱਖ ਖਾਤਾ ਅਤੇ ਸਾਰੇ ਪਰਿਵਾਰਕ ਪ੍ਰੋਫਾਈਲ ਸਥਾਈ ਤੌਰ 'ਤੇ ਮਿਟਾਓ। ਸਭ ਕੁਝ ਬਹਾਲ ਕਰਨ ਲਈ 15 ਦਿਨਾਂ ਵਿੱਚ ਵਾਪਸ ਸਾਈਨ ਇਨ ਕਰੋ।",
    },
    mkCredentialFields({
      desc: "ਆਪਣਾ ਲਾਗਇਨ ਪਾਸਵਰਡ ਅਪਡੇਟ ਕਰੋ",
      current: "ਮੌਜੂਦਾ ਪਾਸਵਰਡ",
      newLabel: "ਨਵਾਂ ਪਾਸਵਰਡ",
      confirm: "ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
      currentPh: "ਮੌਜੂਦਾ ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ",
      newPh: "ਨਵਾਂ ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ",
      confirmPh: "ਨਵੇਂ ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
      confirmRequired: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
      mismatch: "ਪਾਸਵਰਡ ਮੇਲ ਖਾਣੇ ਚਾਹੀਦੇ ਹਨ",
      currentRequired: "ਮੌਜੂਦਾ ਪਾਸਵਰਡ ਲੋੜੀਂਦਾ ਹੈ",
      updating: "ਅਪਡੇਟ ਹੋ ਰਿਹਾ ਹੈ...",
      update: "ਪਾਸਵਰਡ ਅਪਡੇਟ ਕਰੋ",
      changed: "ਪਾਸਵਰਡ ਸਫਲਤਾਪੂਰਵਕ ਬਦਲਿਆ ਗਿਆ",
      invalidCurrent: "ਮੌਜੂਦਾ ਪਾਸਵਰਡ ਗਲਤ ਹੈ",
      changeFailed: "ਪਾਸਵਰਡ ਬਦਲਣ ਵਿੱਚ ਅਸਫਲ",
    })
  ),
  te: mkSettings(
    {
      title: "సెట్టింగ్‌లు",
      heroTitle: "ఖాతా సెట్టింగ్‌లు",
      intro: "మీ ఖాతా భద్రత, చట్టపరమైన పత్రాలు మరియు ఖాతా స్థితిని నిర్వహించండి.",
      termsAndConditions: "నిబంధనలు మరియు షరతులు",
      termsLink: "నిబంధనలు మరియు షరతులు",
      termsLinkDesc: "పూర్తి చట్టపరమైన పత్రాన్ని చూడండి",
      readFullTerms: "పూర్తి నిబంధనలు మరియు షరతులు చదవండి",
      accountActions: "ఖాతా చర్యలు",
      saveChanges: "మార్పులను సేవ్ చేయండి",
      deleteAccount: "ఖాతాను తొలగించండి",
      deleteAccountBadge: "15-రోజుల రికవరీ విండో",
      deleteAccountDesc:
        "మీ ప్రధాన ఖాతా మరియు అన్ని కుటుంబ ప్రొఫైల్‌లను శాశ్వతంగా తొలగించండి. అన్నింటినీ పునరుద్ధరించడానికి 15 రోజులలోపు తిరిగి సైన్ ఇన్ చేయండి.",
    },
    mkCredentialFields({
      desc: "మీ లాగిన్ పాస్‌వర్డ్‌ను అప్‌డేట్ చేయండి",
      current: "ప్రస్తుత పాస్‌వర్డ్",
      newLabel: "కొత్త పాస్‌వర్డ్",
      confirm: "పాస్‌వర్డ్ నిర్ధారించండి",
      currentPh: "ప్రస్తుత పాస్‌వర్డ్ నమోదు చేయండి",
      newPh: "కొత్త పాస్‌వర్డ్ నమోదు చేయండి",
      confirmPh: "కొత్త పాస్‌వర్డ్ నిర్ధారించండి",
      confirmRequired: "దయచేసి మీ పాస్‌వర్డ్‌ను నిర్ధారించండి",
      mismatch: "పాస్‌వర్డ్‌లు సరిపోలాలి",
      currentRequired: "ప్రస్తుత పాస్‌వర్డ్ అవసరం",
      updating: "అప్‌డేట్ అవుతోంది...",
      update: "పాస్‌వర్డ్ అప్‌డేట్ చేయండి",
      changed: "పాస్‌వర్డ్ విజయవంతంగా మార్చబడింది",
      invalidCurrent: "ప్రస్తుత పాస్‌వర్డ్ తప్పు",
      changeFailed: "పాస్‌వర్డ్ మార్చడంలో విఫలమైంది",
    })
  ),
  ta: mkSettings(
    {
      title: "அமைப்புகள்",
      heroTitle: "கணக்கு அமைப்புகள்",
      intro: "உங்கள் கணக்கு பாதுகாப்பு, சட்ட ஆவணங்கள் மற்றும் கணக்கு நிலையை நிர்வகிக்கவும்.",
      termsAndConditions: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      termsLink: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      termsLinkDesc: "முழு சட்ட ஆவணத்தைக் காண்க",
      readFullTerms: "முழு விதிமுறைகள் மற்றும் நிபந்தனைகளைப் படிக்கவும்",
      accountActions: "கணக்கு செயல்கள்",
      saveChanges: "மாற்றங்களைச் சேமிக்கவும்",
      deleteAccount: "கணக்கை நீக்கு",
      deleteAccountBadge: "15-நாள் மீட்பு காலம்",
      deleteAccountDesc:
        "உங்கள் முதன்மை கணக்கு மற்றும் அனைத்து குடும்ப சுயவிவரங்களையும் நிரந்தரமாக நீக்கவும். அனைத்தையும் மீட்டெடுக்க 15 நாட்களுக்குள் மீண்டும் உள்நுழையவும்.",
    },
    mkCredentialFields({
      desc: "உங்கள் உள்நுழைவு கடவுச்சொல்லைப் புதுப்பிக்கவும்",
      current: "தற்போதைய கடவுச்சொல்",
      newLabel: "புதிய கடவுச்சொல்",
      confirm: "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
      currentPh: "தற்போதைய கடவுச்சொல்லை உள்ளிடவும்",
      newPh: "புதிய கடவுச்சொல்லை உள்ளிடவும்",
      confirmPh: "புதிய கடவுச்சொல்லை உறுதிப்படுத்தவும்",
      confirmRequired: "தயவுசெய்து உங்கள் கடவுச்சொல்லை உறுதிப்படுத்தவும்",
      mismatch: "கடவுச்சொற்கள் பொருந்த வேண்டும்",
      currentRequired: "தற்போதைய கடவுச்சொல் தேவை",
      updating: "புதுப்பிக்கப்படுகிறது...",
      update: "கடவுச்சொல்லைப் புதுப்பிக்கவும்",
      changed: "கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது",
      invalidCurrent: "தவறான தற்போதைய கடவுச்சொல்",
      changeFailed: "கடவுச்சொல்லை மாற்ற முடியவில்லை",
    })
  ),
  mr: mkSettings(
    {
      title: "सेटिंग्ज",
      heroTitle: "खाते सेटिंग्ज",
      intro: "तुमच्या खात्याची सुरक्षा, कायदेशीर कागदपत्रे आणि खाते स्थिती व्यवस्थापित करा.",
      termsAndConditions: "अटी आणि शर्ती",
      termsLink: "अटी आणि शर्ती",
      termsLinkDesc: "संपूर्ण कायदेशीर दस्तऐवज पहा",
      readFullTerms: "संपूर्ण अटी आणि शर्ती वाचा",
      accountActions: "खाते क्रिया",
      saveChanges: "बदल जतन करा",
      deleteAccount: "खाते हटवा",
      deleteAccountBadge: "15-दिवसांची पुनर्प्राप्ती मुदत",
      deleteAccountDesc:
        "तुमचे मुख्य खाते आणि सर्व कुटुंब प्रोफाइल कायमस्वरूपी हटवा. सर्व काही पुनर्संचयित करण्यासाठी 15 दिवसांत परत साइन इन करा.",
    },
    mkCredentialFields({
      desc: "तुमचा लॉगिन पासवर्ड अपडेट करा",
      current: "सध्याचा पासवर्ड",
      newLabel: "नवीन पासवर्ड",
      confirm: "पासवर्डची पुष्टी करा",
      currentPh: "सध्याचा पासवर्ड प्रविष्ट करा",
      newPh: "नवीन पासवर्ड प्रविष्ट करा",
      confirmPh: "नवीन पासवर्डची पुष्टी करा",
      confirmRequired: "कृपया तुमच्या पासवर्डची पुष्टी करा",
      mismatch: "पासवर्ड जुळले पाहिजेत",
      currentRequired: "सध्याचा पासवर्ड आवश्यक आहे",
      updating: "अपडेट होत आहे...",
      update: "पासवर्ड अपडेट करा",
      changed: "पासवर्ड यशस्वीरित्या बदलला",
      invalidCurrent: "चुकीचा सध्याचा पासवर्ड",
      changeFailed: "पासवर्ड बदलण्यात अयशस्वी",
    })
  ),
  bn: mkSettings(
    {
      title: "সেটিংস",
      heroTitle: "অ্যাকাউন্ট সেটিংস",
      intro: "আপনার অ্যাকাউন্ট নিরাপত্তা, আইনি নথি এবং অ্যাকাউন্টের অবস্থা পরিচালনা করুন।",
      termsAndConditions: "শর্তাবলী",
      termsLink: "শর্তাবলী",
      termsLinkDesc: "সম্পূর্ণ আইনি নথি দেখুন",
      readFullTerms: "সম্পূর্ণ শর্তাবলী পড়ুন",
      accountActions: "অ্যাকাউন্ট ক্রিয়া",
      saveChanges: "পরিবর্তন সংরক্ষণ করুন",
      deleteAccount: "অ্যাকাউন্ট মুছুন",
      deleteAccountBadge: "15-দিনের পুনরুদ্ধার সময়",
      deleteAccountDesc:
        "আপনার প্রধান অ্যাকাউন্ট এবং সমস্ত পরিবার প্রোফাইল স্থায়ীভাবে মুছুন। সবকিছু পুনরুদ্ধার করতে 15 দিনের মধ্যে আবার সাইন ইন করুন।",
    },
    mkCredentialFields({
      desc: "আপনার লগইন পাসওয়ার্ড আপডেট করুন",
      current: "বর্তমান পাসওয়ার্ড",
      newLabel: "নতুন পাসওয়ার্ড",
      confirm: "পাসওয়ার্ড নিশ্চিত করুন",
      currentPh: "বর্তমান পাসওয়ার্ড লিখুন",
      newPh: "নতুন পাসওয়ার্ড লিখুন",
      confirmPh: "নতুন পাসওয়ার্ড নিশ্চিত করুন",
      confirmRequired: "অনুগ্রহ করে আপনার পাসওয়ার্ড নিশ্চিত করুন",
      mismatch: "পাসওয়ার্ড মিলতে হবে",
      currentRequired: "বর্তমান পাসওয়ার্ড প্রয়োজন",
      updating: "আপডেট হচ্ছে...",
      update: "পাসওয়ার্ড আপডেট করুন",
      changed: "পাসওয়ার্ড সফলভাবে পরিবর্তিত হয়েছে",
      invalidCurrent: "ভুল বর্তমান পাসওয়ার্ড",
      changeFailed: "পাসওয়ার্ড পরিবর্তন ব্যর্থ হয়েছে",
    })
  ),
  kn: mkSettings(
    {
      title: "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
      heroTitle: "ಖಾತೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
      intro: "ನಿಮ್ಮ ಖಾತೆ ಭದ್ರತೆ, ಕಾನೂನು ದಾಖಲೆಗಳು ಮತ್ತು ಖಾತೆ ಸ್ಥಿತಿಯನ್ನು ನಿರ್ವಹಿಸಿ.",
      termsAndConditions: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
      termsLink: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
      termsLinkDesc: "ಪೂರ್ಣ ಕಾನೂನು ದಾಖಲೆಯನ್ನು ವೀಕ್ಷಿಸಿ",
      readFullTerms: "ಪೂರ್ಣ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಓದಿ",
      accountActions: "ಖಾತೆ ಕ್ರಿಯೆಗಳು",
      saveChanges: "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
      deleteAccount: "ಖಾತೆಯನ್ನು ಅಳಿಸಿ",
      deleteAccountBadge: "15-ದಿನಗಳ ಮರುಪಡೆಯುವಿಕೆ ಅವಧಿ",
      deleteAccountDesc:
        "ನಿಮ್ಮ ಮುಖ್ಯ ಖಾತೆ ಮತ್ತು ಎಲ್ಲಾ ಕುಟುಂಬ ಪ್ರೊಫೈಲ್‌ಗಳನ್ನು ಶಾಶ್ವತವಾಗಿ ಅಳಿಸಿ. ಎಲ್ಲವನ್ನೂ ಮರುಸ್ಥಾಪಿಸಲು 15 ದಿನಗಳೊಳಗೆ ಮತ್ತೆ ಸೈನ್ ಇನ್ ಮಾಡಿ.",
    },
    mkCredentialFields({
      desc: "ನಿಮ್ಮ ಲಾಗಿನ್ ಪಾಸ್‌ವರ್ಡ್ ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
      current: "ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್",
      newLabel: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್",
      confirm: "ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
      currentPh: "ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ",
      newPh: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ",
      confirmPh: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
      confirmRequired: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
      mismatch: "ಪಾಸ್‌ವರ್ಡ್‌ಗಳು ಹೊಂದಿಕೆಯಾಗಬೇಕು",
      currentRequired: "ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್ ಅಗತ್ಯ",
      updating: "ಅಪ್‌ಡೇಟ್ ಆಗುತ್ತಿದೆ...",
      update: "ಪಾಸ್‌ವರ್ಡ್ ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
      changed: "ಪಾಸ್‌ವರ್ಡ್ ಯಶಸ್ವಿಯಾಗಿ ಬದಲಾಯಿತು",
      invalidCurrent: "ತಪ್ಪಾದ ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್",
      changeFailed: "ಪಾಸ್‌ವರ್ಡ್ ಬದಲಾಯಿಸಲು ವಿಫಲವಾಗಿದೆ",
    })
  ),
};

const COMMON_CANCEL_BY_LANG = {
  hi: "रद्द करें",
  pa: "ਰੱਦ ਕਰੋ",
  te: "రద్దు",
  ta: "ரத்து",
  mr: "रद्द",
  bn: "বাতিল",
  kn: "ರದ್ದು",
};

export const applySettingsLocaleBlocks = (translations) => {
  Object.entries(SETTINGS_LOCALE_BLOCKS).forEach(([lang, settings]) => {
    if (!translations[lang]) return;
    translations[lang].settings = {
      ...translations[lang].settings,
      ...settings,
    };
    const cancel = COMMON_CANCEL_BY_LANG[lang];
    if (cancel && translations[lang].common) {
      translations[lang].common = {
        ...translations[lang].common,
        cancel,
      };
    }
  });
};
